// components/Employee/CreateEmployee.js
import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { Input } from '../UI/Input.js';
import { Dropdown } from '../UI/Dropdown.js';
import { Button } from '../UI/Button.js';
import CustomDatePicker from '../Common/DatePicker';
import { FormContainer, FullWidth } from '../../styles/sharedStyles';

const CreateEmployee = () => {
  const [name, setName] = useState('');
  const [surnames, setSurnames] = useState('');
  const [birthDate, setBirthDate] = useState(null);
  const [pin, setPin] = useState('');
  const [username, setUsername] = useState('');
  const [pwd, setPwd] = useState('');
  const [roles, setRoles] = useState([]);
  const [selectedRoleId, setSelectedRoleId] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await api.get('/roles');
        setRoles(response.data);
      } catch (error) {
        console.error('Failed to fetch roles', error);
      }
    };
    fetchRoles();
  }, []);

  const handleCreate = async () => {
  try {
    const payload = {
      name,
      surnames,
      secret_pin: pin,
	  username: username,
	  password: pwd,
	  role_id: selectedRoleId
    };
    if (birthDate) {
      payload.birth_date = birthDate.toLocaleDateString('en-CA');
    }
    await api.post('/employees', payload);
    alert('Employee created successfully!');
    setName('');
    setSurnames('');
    setBirthDate(null);
    setPin('');
	setUsername('');
	setPwd('');
	setSelectedRoleId('');
  } catch (error) {
    console.error('Employee creation failed', error);
    alert('Employee creation failed. Please check the input.');
  }
};

  return (
    <div>
      <h2>Añadir Empleado</h2>
      <FormContainer>
        <Input type="text" placeholder="Nombre" value={name} onChange={(e) => setName(e.target.value)} required />
        <Input type="text" placeholder="Apellidos" value={surnames} onChange={(e) => setSurnames(e.target.value)} required />
        <FullWidth>
          <CustomDatePicker selected={birthDate} onChange={(date) => setBirthDate(date)} placeholder="Fecha de nacimiento" />
        </FullWidth>
        <FullWidth>
          <Input type="text" placeholder="PIN" value={pin} onChange={(e) => setPin(e.target.value)} required />
        </FullWidth>
		<Input type="text" placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} required />
		<div style={{ position: 'relative' }}>
		<Input
           type={showPassword ? 'text' : 'password'}
           placeholder="Password"
           value={pwd}
           onChange={(e) => setPwd(e.target.value)}
           required
         />
		 <span
             onClick={() => setShowPassword(prev => !prev)}
             style={{
               position: 'absolute',
               right: '10px',
               top: '35%',
               transform: 'translateY(-50%)',
               cursor: 'pointer'
             }}
           >
             {showPassword ? '🙈' : '👁️'}
           </span>
         </div>
		<FullWidth>
        <Dropdown value={selectedRoleId} onChange={(e) => setSelectedRoleId(e.target.value)} required>
          <option value="">Selecciona el rol del empleado</option>
          {roles.map((role) => (
            <option key={role.role_id} value={role.role_id}>
              {role.role_title}
            </option>
          ))}
        </Dropdown>
</FullWidth>
        <FullWidth>
          <Button onClick={handleCreate}>Crear</Button>
        </FullWidth>
      </FormContainer>
    </div>
  );
};

export default CreateEmployee;